export const EDITING_SUBSCRIPTION_DETAILS_MODAL_NAME =
  'EDITING_SUBSCRIPTION__DETAILS_MODAL_NAME';
